import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ExpandSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ExpandSVG;
